<template>
  <!--新建工单弹窗-->
  <el-dialog
    :visible.sync="dialogVisible"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    top="5vh"
    width="80%"
    :before-close="handleClose">

    <el-tabs
      class="new_ticket_tabs"
      slot="title"
      v-model="activeTab" type="card"
      @tab-click="onTabClick"
      style="border-bottom:1px solid #DCDFE6;width: 100%;">
      <el-tab-pane label="新建普通工单"/>
      <el-tab-pane label="新建模板工单"/>
      <el-tab-pane label="新建普通工单(新版)"/>
    </el-tabs>

    <!-- 普通工单 -->
    <div v-if="0==activeTab" style="display: flex;">
      <el-form
        :model="ticketNew"
        ref="formRef"
        :rules="rules"
        label-width="80px"
        style="width:75%">
        <el-form-item label="标题" prop="orderTitle" style="margin-right: 40px;">
          <el-input type="textarea" autosize v-model="ticketNew.orderTitle" placeholder="工单标题" clearable/>
        </el-form-item>
        <el-row>
          <el-col :span="8">
            <el-form-item label="类型" prop="orderType">
              <TicketTypeCascader
                css="width:100%"
                v-model="ticketNew.orderType" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="优先级" prop="orderPriority">
              <el-select v-model="ticketNew.orderPriority" clearable placeholder="请选择" style="width:100%">
                <el-option
                  v-for="(ll) in orderPriorityList"
                  :key="ll.id"
                  :label="ll.name"
                  :value="ll.id" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="内容" prop="orderContent" style="width:100%;padding-right:40px;padding-bottom:10px;">
          <EditorSummernote ref="summernote_2"/> <!-- 富文本内容编辑框 -->

          <TicketUploadList ref="upList" :ticketUpload="$refs.up2"/> <!-- 上传文件列表 -->

          <TicketTemplateSelect @selected="onTicketTemplateSelected"/> <!-- 工单模板选择 -->

          <TicketUpload ref="up2" :ticketUploadList="$refs.upList"/> <!-- 上传按钮 -->
        </el-form-item>
        <el-row>
          <el-col :span="8">
            <el-form-item label="联系人" prop="contactUserName">
              <el-input v-model="ticketNew.contactUserName" placeholder="请输入联系人" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系电话" prop="contactUserPhone">
              <el-input v-model="ticketNew.contactUserPhone" placeholder="请输入联系电话" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="处理人" prop="assignUserId">
              <DealUserSearch css="width:100%" @change="updateAssignUserId" ref="assignUser" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="关联商家" prop="merchantId">
              <MerchantSearch css="width:100%" @change="updateMerchantId" ref="merchantId" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="抄送人">
              <NoticeUserSearch
                css="width: 100%;"
                @change="updateMessageGroupId"
                :id="ticketNew.orderNoticeList"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="关联订单" prop="merchantOrderId">
              <MerchantOrderSearch css="width: 100%;" @change="updateMerchantOrderId" ref="merchantOrderId" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="关联项目">
              <TicketProjectSelect style="width:100%;" v-model="ticketNew.projectIdArray" ref="ticketProjectSelect"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
          </el-col>
          <el-col :span="8">
            <el-form-item label="标签">
              <TicketTag v-model="ticketNew.ticketTagArray" pmode='detail' ref="ticketTag"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
          </el-col>
        </el-row>
      </el-form>

      <!-- 新建工单时推荐相关工单 -->
      <NewTicketRelated :orderTitle="ticketNew.orderTitle"/>
    </div>

    <!-- 模板工单 -->
    <div v-if="1==activeTab" style="min-height:45vh;padding-left:20px;">
      <a v-for="e in ticketTemplateList"
        :title="'点击打开新建工单页面 创建 ' + e.name"
        :key="e.id"
        class="el-button"
        style="margin:10px;font-size:18px;padding:5px 10px!important;height:45px!important;"
        :href="'/ticket-vue/new-ticket?templateId=' + e.id">{{e.name}}</a>
    </div>

    <!-- 新建普通工单(新版) -->
    <div v-if="2 == activeTab" class="new-ticket-tab-content">
      新建普通工单 正在
      <a href="/ticket-vue/new-ticket?136">跳转</a>
      到新建页面
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <SubmitTicketButton v-if="0 == activeTab"
        @click="insertTicket"
        ref="submitBtn"/>
    </span>
  </el-dialog>
</template>

<script>
var TICKET_NEW = {
  orderType: "", //工单类型
  orderTitle: "", //工单标题
  orderPriority: "", //优先级
  orderContent: "", //工单内容
  contactUserName: "", //联系人
  contactUserPhone: "", //联系电话
  assignUserId: "", //处理人
  orderNoticeList: [] //通知列表
};

export default {
  name: "NewTicketDialog",

  data() {
    return {
      ticketTemplateList : [],
      activeTab : '0',
      token: null,
      dialogVisible: false,
      fileList: [], //已上传凭证列表
      ticketNew: TICKET_NEW,

      rules: {
        orderTitle: [
          { required: true }
        ]
      }
    };
  },

  watch : {
    activeTab() {
      if ( 1 == this.activeTab ) { // 模板列表
        var _this = this;

        sdk.TicketTemplateApi().listMyTemplateByTypeCached({
          type : 'Workflow',
          page : { pageSize : 9999, orderBy : "`index` ASC" }
        }).then((res)=>{
          _this.ticketTemplateList = res.list;
        });
      }
    }
  },

  methods: {
    onTabClick( _this ) {
      if ( "2" == _this.index ) {
        location.href = "/ticket-vue/new-ticket?164";
      }
    },

    onTicketTemplateSelected(ticketTemplate) {
      if ( !ticketTemplate || !ticketTemplate.content ) {
        console.log("#55 ticketTemplate is empty", ticketTemplate);
        _message("模板为空");
        return;
      }

      var _editorContent = this.$refs.summernote_2.summernoteGetCode();
      var _newContent = "";
      if ( !!_editorContent ) {
        _newContent += _editorContent + "<br/><br/>";
      }

      _newContent += ticketTemplate.content;

      this.$refs.summernote_2.summernoteSetCode( _newContent );
    },

    // 弹出层打开-新建工单
    showNewTicketDialog() {
      var self = this;
      this.dialogVisible = true;

      // 加载当前用户信息作为联系人
      sdk.TicketUserApi().currentUserCached().then(res => {
        if ( !!res ) {
          self.ticketNew.contactUserName = res.name;
          self.ticketNew.contactUserPhone = res.phone;
        }

        console.log('#198 currentUserCached is null', res);
      });
    },

    updateAssignUserId(value) {
      this.ticketNew.assignUserId = value;
    },

    updateMerchantId(_val) {
      this.ticketNew.merchantId = _val.id;
    },

    updateMessageGroupId(value) {
      this.ticketNew.orderNoticeList = [];
      value.map(item => {
        this.ticketNew.orderNoticeList.push({ noticeUserId: item.id });
      });
    },

    updateMerchantOrderId(_val) {
      this.ticketNew.merchantOrderId = _val.id;
    },

    // 弹出层关闭-新建工单
    handleClose() {
      if ( !!this.$refs["formRef"] ) {
        this.$refs["formRef"].resetFields();
      }

      this.dialogVisible = false;
      this.ticketNew.orderNoticeList = [];
    },

    onCreateTicketResponse(response) {
      var _this = this;
      _this.$refs.submitBtn.enable();

      var result = response.data;
      if ( result.status ) {
        _message("创建工单成功");

        // 清理
        _this.$refs.assignUser.clearValue();
        _this.$refs.merchantId.setValue(null);
        _this.$refs.merchantOrderId.setValue(null);

        _this.$refs.summernote_2.summernoteSetCode("");

        _this.$refs.up2.clearFile(); // TicketUpload

        _this.$refs.upList.deleteAll(); // TicketUploadList

        _this.$refs.ticketProjectSelect.clearValue();

        _this.$refs.ticketTag.clearValue();

        _this.handleClose();

        _this.$parent.$refs.ticketList.queryTicketList();
        return;
      }

      if (!!result.message) {
        _this.$alert(result.message);
        return;
      }

      _this.$alert("工单系统服务器异常 #599");
    },

    //新建工单
    insertTicket() {
      if ( !this.$refs["formRef"] ) {
        _message("选择模板或切换到普通工单");
        return;
      }

      var _this = this;
      _this.$refs.submitBtn.disable();

      _this.ticketNew.orderContent = this.$refs.summernote_2.summernoteGetCode();

      this.$refs.formRef.validate(valid => {
        if (!valid) {
          return false;
        }

        if (!_this.ticketNew.orderType) {
          _this.ticketNew.orderSuperType = null;
        } else if (_this.ticketNew.orderType < 3) {
          _this.ticketNew.orderSuperType = _this.ticketNew.orderType;
        } else {
          _this.ticketNew.orderSuperType = null;
        }

        if ( !!_this.ticketNew.projectIdArray ) {
          _this.ticketNew.projectIdArray = _this.ticketNew.projectIdArray.join(",")
        }

        if ( !!_this.ticketNew.ticketTagArray ) {
          _this.ticketNew.ticketTagArray = _this.ticketNew.ticketTagArray.join(",")
        }

        _this.ticketNew.attachmentList = _this.$refs.up2.getAttachmentList();

        var _url = "/ticket/v2-workOrder/create";

        _this.$http.post(_url, _this.ticketNew).then(_this.onCreateTicketResponse, () => {
              _this.$refs.submitBtn.enable();

              _this.$alert("网络繁忙，请稍后重试 #604");
            }
          );
      });
    }
  }
};
</script>

<style>
.new-ticket-tab-content {
  text-align: center;
  padding: 10vh 0;
  font-size: 3vw;
  color: #e8e8e8;
}

.el-dialog__header {
    padding-left: 0;
    padding-right: 0;
    padding-top: 20px;
}
.new_ticket_tabs .el-tabs__header {
  border-bottom-width:  0;
}
.new_ticket_tabs  .el-tabs__header {
  margin:0;
}
.new_ticket_tabs .el-tabs__nav {
  margin-left: 90px;
}
.new_ticket_tabs .el-tabs__item {
  font-size:15px;
}
</style>


// WEBPACK FOOTER //
// src/components/ticket/NewTicketDialog.vue